import { createRouter, createWebHistory } from 'vue-router';

import { routes } from '@/config/routes';
import { txc } from '@/modules/i18n';
import * as User from '@/modules/user';
import * as Notifications from '@/modules/notifications';
import * as Debug from '@/modules/debug';


export const router = createRouter( { history: createWebHistory(), routes } );


//

router.beforeEach( async ( to, from ) =>
{
	if ( to.meta?.redirect_if_logged_in && User.Is_logged_in() )
		return { name: to.meta.redirect_if_logged_in };
	
	else if ( to.meta?.redirect_if_logged_out && !User.Is_logged_in() )
		return { name: to.meta.redirect_if_logged_out };
} );